import { QuestionsService } from 'data/services';
import { QuestionsServiceInterface } from 'domain/services';
import { makeRemoteCloneQuestion } from 'main/factories/usecases/evaluation-criteria/questions/clone-question-factory';
import { makeRemoteCreateQuestion } from 'main/factories/usecases/evaluation-criteria/questions/create-question-factory';
import { makeRemoteDeleteQuestion } from 'main/factories/usecases/evaluation-criteria/questions/delete-question-factory';
import { makeRemoteGetAllQuestions } from 'main/factories/usecases/evaluation-criteria/questions/get-all-questions-factory';
import { makeRemoteGetQuestionById } from 'main/factories/usecases/evaluation-criteria/questions/get-question-by-id-factory';
import { makeRemoteReorderQuestions } from 'main/factories/usecases/evaluation-criteria/questions/reorder-questions-factory';
import { makeRemoteUpdateQuestion } from 'main/factories/usecases/evaluation-criteria/questions/update-question-factory';

export const makeQuestionsService = (): QuestionsServiceInterface => {
  return new QuestionsService({
    getAllQuestions: makeRemoteGetAllQuestions(),
    reorderQuestions: makeRemoteReorderQuestions(),
    createQuestion: makeRemoteCreateQuestion(),
    updateQuestion: makeRemoteUpdateQuestion(),
    getQuestionById: makeRemoteGetQuestionById(),
    deleteQuestion: makeRemoteDeleteQuestion(),
    cloneQuestion: makeRemoteCloneQuestion(),
  });
};
